import { Button, Col, Flex, Input, Row, Space } from "antd";
import FormItem from "antd/es/form/FormItem";
import Dragger from "antd/lib/upload/Dragger";
import { FormDatePicker, FormInput, FormInputNumber, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useTranslation } from "react-i18next";
import { ReactComponent as UploadIcon } from "../../../assets/icon/uploadIcon.svg"
import { useEffect, useState } from "react";
import cx from "classnames";
import styles from "../styles/Expense.module.css";
import FormTimePicker from "components/form/FormProvide/FormTimePicker";
import { useForm } from "antd/es/form/Form";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import { CloudUploadOutlined } from "@ant-design/icons";

const VAT_RATE = 0.07;

const FIXED_CURRENCY_LABEL = "THB";

const CreateExpenseForm = ({
    setIsExpenseModalOpen = () => { },
    dropdownProjectByEmployeeId = [],
    EmployeeWelfareDropdown = [],
    createTxnExpense = () => { },
    createTxnExpenseDraft = () => { },
    CommonTypeByCode = [],
    isCreateExpenseForm = false,
    isExpenseModalOpen = false,
    form,
    welfareTypeCode,
    setWelfareTypeCode = () => { },
    onAttachFileChange = () => { },
    onDeleteFile = () => { }
}) => {
    const { t, i18n } = useTranslation();
    const [fileSizeInMB, setfileSizeInMB] = useState([]);
    const [fileName, seeFileName] = useState([]);
    const [imageUrl, setImageUrl] = useState([]);
    const [fileType, setFileType] = useState([]);
    const [initialValuesFileName, setInitialValuesFileName] = useState([]);
    const [initialValuesImageUrl, setInitialValuesImageUrl] = useState([]);
    const [initialValuesFileType, setInitialValuesFileType] = useState([]);
    const [initialValuesFileList, setInitialValuesFileList] = useState([]);

    const { employeeInfo } = useSelector((state) => state.expense);

    const employeeFullname = i18n.language == "en" ? `${employeeInfo?.nameEn} ${employeeInfo?.surNameEn}` : `${employeeInfo?.name} ${employeeInfo?.surName}`;

    // * auto-calc "amount excl. VAT" and "VAT" whenever total (incl. VAT) changes
    const handleTotalExpenseChange = (val) => {
        const totalInclVat = Number(val) || 0;
        const amountExcludeVat = totalInclVat / (1 + VAT_RATE);
        const vatAmount = totalInclVat - amountExcludeVat;
        form.setFieldValue("amountExcludeVat", amountExcludeVat.toFixed(2));
        form.setFieldValue("vatAmount", vatAmount.toFixed(2));
    };

    const openBase64InNewTab = (base64Data, mimeType = "application/pdf") => {
        try {
            if (base64Data.startsWith("blob:") || base64Data.startsWith("http")) {
                window.open(base64Data, "_blank", "noopener,noreferrer");
                return;
            }

            const base64 = base64Data.includes(",")
                ? base64Data.split(",")[1]
                : base64Data;

            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: mimeType });
            const blobUrl = URL.createObjectURL(blob);

            window.open(blobUrl, "_blank", "noopener,noreferrer");
            setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);

        } catch (error) {
            console.error("openBase64InNewTab error:", error);
            window.open(base64Data, "_blank", "noopener,noreferrer");
        }
    };
    useEffect(() => {
        form.setFieldValue("currencyDisplay", i18n.language === "en" ? "THB" : "บาท");
    }, [i18n.language, form]);
    return (
        <FormAntd
            form={form}
            onFinish={(values) => {
                const allValues = form.getFieldsValue(true);
                createTxnExpense({ ...values, ...allValues });
            }}
        >
            <FormItem shouldUpdate={(prev, curv) => {
                return prev.welfareTypeId !== curv.welfareTypeId
            }}>
                {({ getFieldValue, resetFields, setFieldValue }) => {
                    const attachment = getFieldValue("attachment");

                    return (
                        <Space direction="vertical" size={24} style={{ width: "100%" }}>
                            <Row gutter={[0, 16]}>
                                <Col span={24}>
                                    <FormSelect
                                        name="welfareTypeId"
                                        label={t("expense.expense_type")}
                                        placeholder={t("common.pleaseSelect")}
                                        size="large"
                                        options={EmployeeWelfareDropdown}
                                        onChange={(val, option) => {
                                            resetFields([
                                                "travelBy",
                                                "projectId",
                                                "startLocation",
                                                "destination",
                                                "distance",
                                                "totalNights",
                                                "totalMinutes",
                                                "userRights",
                                                "description",
                                            ]);

                                            const selectedOption = EmployeeWelfareDropdown.find(opt => opt.value === val);
                                            setWelfareTypeCode(selectedOption?.code);
                                            form.setFieldValue("welfareTypeCode", selectedOption?.code);
                                            form.setFieldValue("attachment", selectedOption?.attachmentFlag);
                                            form.setFieldValue("remainingCredit", selectedOption?.remainingCredit != null
                                                ? get2DecimalPointsWithCommas(selectedOption.remainingCredit)
                                                : null);
                                            form.setFieldValue("remainingRequest", selectedOption?.remainingRequest);
                                        }}
                                        required
                                    />
                                </Col>

                                <Col span={12} style={{ paddingRight: "12px" }}>
                                    <FormDatePicker
                                        name="startDate"
                                        label={t("start-date")}
                                        placeholder={t("common.pleaseSelect")}
                                        size="large"
                                        required
                                    // disabled={isViewExpenseForm}
                                    />
                                </Col>
                                <Col span={12} style={{ paddingLeft: "12px" }}>
                                    <FormDatePicker
                                        name="endDate"
                                        label={t("end-date")}
                                        placeholder={t("common.pleaseSelect")}
                                        size="large"
                                        required
                                    />
                                </Col>

                                <Row gutter={[0, 16]}>
                                    <Col span={12} style={{ paddingRight: "12px" }}>
                                        <FormInput
                                            name="remainingCredit"
                                            label={t("expense.remaining_balance")}
                                            placeholder={t("unlimited")}
                                            textAlign="right"
                                            size="large"
                                            disabled
                                        />
                                    </Col>

                                    <Col span={12} style={{ paddingLeft: "12px" }}>
                                        <FormInput
                                            name="remainingRequest"
                                            label={t("expense.remaining_request")}
                                            placeholder={t("unlimited")}
                                            textAlign="right"
                                            size="large"
                                            disabled
                                        />
                                    </Col>
                                </Row>
                                {welfareTypeCode === "WELFARE_SUBCATEGORY_1" && (
                                    <>
                                        <Col span={24} >
                                            <FormSelect
                                                name="travelBy"
                                                label={t('expense.travel_directions')}
                                                placeholder={t("common.please_fill")}
                                                size="large"
                                                options={CommonTypeByCode}
                                                required
                                            />
                                        </Col>

                                        <Col span={24}>
                                            <FormSelect
                                                name="projectId"
                                                label={t("my_timesheet.label.select_proj")}
                                                placeholder={t("common.pleaseSelect")}
                                                size="large"
                                                options={[
                                                    ...(dropdownProjectByEmployeeId?.map(item => ({
                                                        value: item.stpTimeSheetId,
                                                        label: i18n.language === "en" ? item.projectNameEn : item.projectName
                                                    })) || []),
                                                    { value: null, label: t("expense.no_project") }
                                                ]}
                                            />
                                        </Col>

                                        <Col span={12} style={{ paddingRight: "12px" }}>
                                            <FormInput
                                                name="startLocation"
                                                label={t("expense.starting_point")}
                                                placeholder={t("common.please_fill")}
                                                size="large"
                                                required
                                            />
                                        </Col>
                                        <Col span={12} style={{ paddingLeft: "12px" }}>
                                            <FormInput
                                                name="destination"
                                                label={t("expense.destination")}
                                                placeholder={t("common.please_fill")}
                                                size="large"
                                                required
                                            />
                                        </Col>
                                        <Col span={24}>
                                            <FormInputNumber
                                                name="distanceKm"
                                                label={t("expense.distance")}
                                                placeholder={t("common.please_fill")}
                                                size="large"
                                                controls={false}
                                                precision={0}
                                                required
                                            />
                                        </Col>
                                    </>
                                )}
                                {welfareTypeCode === "WELFARE_SUBCATEGORY_2" && (
                                    <>
                                        <Col span={12} style={{ paddingRight: "12px" }}>
                                            <FormInput
                                                name="startLocation"
                                                label={t("expense.starting_point")}
                                                placeholder={t("common.please_fill")}
                                                size="large"
                                                required
                                            />
                                        </Col>
                                        <Col span={12} style={{ paddingLeft: "12px" }}>
                                            <FormInput
                                                name="destination"
                                                label={t("expense.destination")}
                                                placeholder={t("common.please_fill")}
                                                size="large"
                                                required
                                            />
                                        </Col>
                                        <Col span={24}>
                                            <FormSelect
                                                name="projectId"
                                                label={t("my_timesheet.label.select_proj")}
                                                placeholder={t("common.pleaseSelect")}
                                                size="large"
                                                options={[
                                                    ...(dropdownProjectByEmployeeId?.map(item => ({
                                                        value: item.stpTimeSheetId,
                                                        label: i18n.language === "en" ? item.projectNameEn : item.projectName
                                                    })) || []),
                                                    { value: null, label: t("expense.no_project") }
                                                ]}
                                            />
                                        </Col>

                                        <Col span={24}>
                                            <FormInputNumber
                                                name="distanceKm"
                                                label={t("expense.distance")}
                                                placeholder={t("common.please_fill")}
                                                size="large"
                                                controls={false}
                                                precision={0}
                                                required
                                            />
                                        </Col>
                                    </>
                                )}
                                {welfareTypeCode === "WELFARE_SUBCATEGORY_3" && (
                                    <>
                                        <Col span={24}>
                                            <FormSelect
                                                name="projectId"
                                                label={t("my_timesheet.label.select_proj")}
                                                placeholder={t("common.pleaseSelect")}
                                                size="large"
                                                options={[
                                                    ...(dropdownProjectByEmployeeId?.map(item => ({
                                                        value: item.stpTimeSheetId,
                                                        label: i18n.language === "en" ? item.projectNameEn : item.projectName
                                                    })) || []),
                                                    { value: null, label: t("expense.no_project") }
                                                ]}
                                            />
                                        </Col>
                                        <Col span={24}>
                                            <FormInputNumber
                                                name="totalNights"
                                                label={t("expense.number_of_stay")}
                                                placeholder={t("common.please_fill")}
                                                size="large"
                                                controls={false}
                                                precision={0}
                                            />
                                        </Col>
                                    </>
                                )}

                                {welfareTypeCode === "WELFARE_SUBCATEGORY_4" && (
                                    <>
                                        <Col span={24}>
                                            <FormSelect
                                                name="projectId"
                                                label={t("my_timesheet.label.select_proj")}
                                                placeholder={t("common.pleaseSelect")}
                                                size="large"
                                                options={[
                                                    ...(dropdownProjectByEmployeeId?.map(item => ({
                                                        value: item.stpTimeSheetId,
                                                        label: i18n.language === "en" ? item.projectNameEn : item.projectName
                                                    })) || []),
                                                    { value: null, label: t("expense.no_project") }
                                                ]}
                                            />
                                        </Col>

                                        <Col span={24} >
                                            <FormTimePicker
                                                name="totalMinutes"
                                                minuteStep={30}
                                                label={t("expense.duration")}
                                                placeholder={t("common.pleaseSelect")}
                                                size="large"
                                                showNow={false}
                                            />
                                        </Col>
                                    </>
                                )}
                                {welfareTypeCode === "WELFARE_SUBCATEGORY_5" && (
                                    <>
                                        <Col span={24} >
                                            <FormSelect
                                                name="userRights"
                                                label={t('welfare_list.Select_user_rights')}
                                                placeholder={employeeFullname}
                                                size="large"
                                                disabled
                                            // required
                                            />
                                        </Col>
                                    </>
                                )}

                                {welfareTypeCode === "WELFARE_SUBCATEGORY_6" && (
                                    <>
                                        <Col span={24}>
                                            <FormSelect
                                                name="projectId"
                                                label={t("my_timesheet.label.select_proj")}
                                                placeholder={t("common.pleaseSelect")}
                                                size="large"
                                                options={[
                                                    ...(dropdownProjectByEmployeeId?.map(item => ({
                                                        value: item.stpTimeSheetId,
                                                        label: i18n.language === "en" ? item.projectNameEn : item.projectName
                                                    })) || []),
                                                    { value: null, label: t("expense.no_project") }
                                                ]}
                                            />
                                        </Col>
                                    </>

                                )}

                                {/* ===== Invoice detail block: shared across every expense type ===== */}
                                {welfareTypeCode && (
                                    <>
                                        <Col span={24}>
                                            <label className={cx("label", styles.label)}>
                                                {t("expense.invoice_detail")}
                                            </label>
                                        </Col>
                                        <Row>
                                            <Col span={8} style={{ paddingRight: "12px" }}>
                                                <FormDatePicker
                                                    name="invoiceDate"
                                                    label={t("expense.invoice_date")}
                                                    placeholder={t("common.pleaseSelect")}
                                                    size="large"
                                                    required
                                                />
                                            </Col>
                                            <Col span={8} >
                                                <FormInput
                                                    name="invoiceNumber"
                                                    label={t("expense.invoice_number")}
                                                    placeholder={t("common.please_fill")}
                                                    size="large"
                                                // required
                                                />
                                            </Col>
                                            <Col span={8} style={{ paddingLeft: "12px" }}>
                                                <FormInput
                                                    name="currencyDisplay"
                                                    label={t("expense.currency")}
                                                    size="large"
                                                    disabled
                                                    initialValue={i18n.language?.startsWith("en") ? "THB" : "บาท"}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={8} style={{ paddingRight: "12px" }}>
                                                <FormInputNumber
                                                    name="totalExpense"
                                                    label={t("expense.amount_Bath")}
                                                    placeholder={t("common.please_fill")}
                                                    size="large"
                                                    controls={false}
                                                    textAlign="right"
                                                    required
                                                // onChange={handleTotalExpenseChange}
                                                />
                                            </Col>
                                            <Col span={8} >
                                                <FormInputNumber
                                                    name="amountExcludeVat"
                                                    label={t("expense.amount_exclude_vat")}
                                                    textAlign="right"
                                                    controls={false}
                                                    size="large"
                                                // disabled
                                                />
                                            </Col>
                                            <Col span={8} style={{ paddingLeft: "12px" }}>
                                                <FormInputNumber
                                                    name="vatAmount"
                                                    label={t("expense.vat")}
                                                    textAlign="right"
                                                    controls={false}
                                                    size="large"
                                                // disabled
                                                />
                                            </Col>
                                        </Row>
                                    </>
                                )}
                                <Col span={24}>
                                    <FormInput
                                        name="description"
                                        label={t("common.desciption")}
                                        placeholder={t("common.please_fill")}
                                        size="large"
                                        rows="4"
                                        type="textarea"
                                        required

                                    />
                                </Col>
                                {attachment === 'Y' && (
                                    <Col span={24}>
                                        <>
                                            <Dragger
                                                name="attachFile"
                                                multiple={false}
                                                showUploadList={false}
                                                onRemove={() => {
                                                    onDeleteFile();
                                                }}
                                                onChange={(e) => {
                                                    if (e.event) {
                                                        onAttachFileChange({
                                                            attachFile: e,
                                                            setFieldValue: (key, val) => form.setFieldValue(key, val),
                                                            setImageUrl,
                                                            seeFileName,
                                                            initialValuesImageUrl,
                                                            initialValuesFileName,
                                                            initialValuesFileType,
                                                            initialValuesFileList,
                                                            setInitialValuesFileName,
                                                            setInitialValuesFileType,
                                                            setInitialValuesImageUrl,
                                                            setInitialValuesFileList,
                                                            setFileType
                                                        });
                                                    }
                                                }}
                                                style={{
                                                    border: "1px solid #EAECF0",
                                                    borderRadius: "10px",
                                                    background: "#FAFAFA",
                                                    padding: "20px",
                                                }}
                                            >
                                                <p className="ant-upload-drag-icon">
                                                    <CloudUploadOutlined style={{ fontSize: "32px", color: "#888" }} />
                                                </p>
                                                <p
                                                    className="ant-upload-text"
                                                    style={{ fontSize: "16px", fontWeight: "500", color: "#4A4A4A" }}
                                                >
                                                    {t("description.Select the desired file or drag and drop")}
                                                </p>
                                            </Dragger>
                                            <p>{t('description.Supported files mb')}</p>
                                        </>
                                    </Col>
                                )}

                                {imageUrl && (
                                    <>
                                        {imageUrl?.map((attachFile, index) => (
                                            <Col span={24} key={attachFile + index} style={index === 0 ? { marginTop: "24px" } : undefined}>
                                                <Flex vertical gap={4}>
                                                    {index === 0 && (
                                                        <label className={cx("label", styles.label)}>
                                                            {t('employee.label.attachment-file')}
                                                        </label>
                                                    )}

                                                    <Row>
                                                        <div
                                                            style={{
                                                                border: "2px solid var(--button-color)",
                                                                borderRadius: "10px",
                                                                padding: "10px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "space-between",
                                                                width: "100%",
                                                                maxWidth: "600px",
                                                                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                                                                marginTop: "10px"
                                                            }}
                                                        >
                                                            <a
                                                                onClick={() => { openBase64InNewTab(attachFile, fileType[index]) }}
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    textDecoration: "none",
                                                                }}
                                                            >
                                                                <img
                                                                    src={attachFile}
                                                                    alt="uploaded"
                                                                    onError={(e) => {
                                                                        e.target.onerror = null;
                                                                        e.target.style.display = "none";
                                                                        const fallbackElement = e.target.nextElementSibling;
                                                                        if (fallbackElement) fallbackElement.style.display = "block";
                                                                    }}
                                                                    style={{
                                                                        width: "50px",
                                                                        height: "50px",
                                                                        objectFit: "cover",
                                                                        borderRadius: "5px",
                                                                        marginRight: "10px",
                                                                    }}
                                                                />
                                                                <div style={{ flex: 1 }}>
                                                                    <div style={{ fontWeight: "bold", color: "#333", width: "350px" }}>{fileName[index]}</div>
                                                                    <div style={{ fontSize: "12px", color: "#888" }}>{fileSizeInMB[index]} MB</div>
                                                                </div>
                                                            </a>
                                                            <Button
                                                                type="default"
                                                                style={{
                                                                    background: "none",
                                                                    border: "none",
                                                                    color: "#888",
                                                                    cursor: "pointer",
                                                                    fontSize: "18px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                }}

                                                                onClick={() => {
                                                                    const currentAttachFile = getFieldValue("attachFile") || [];
                                                                    const currentAttachFileType = getFieldValue("attachFileType") || [];
                                                                    const currentAttachFileName = getFieldValue("attachFileName") || [];

                                                                    const newImage = imageUrl.filter((_, i) => i !== index);
                                                                    const newfileName = fileName.filter((_, i) => i !== index);
                                                                    const newfileSize = fileSizeInMB.filter((_, i) => i !== index);
                                                                    const newfileType = fileType.filter((_, i) => i !== index);

                                                                    setImageUrl(newImage);
                                                                    seeFileName(newfileName);
                                                                    setfileSizeInMB(newfileSize);
                                                                    setInitialValuesFileName(newfileName);
                                                                    setInitialValuesImageUrl(newImage);
                                                                    setInitialValuesFileType(newfileType);
                                                                    setInitialValuesFileList(currentAttachFile.filter((_, i) => i !== index));

                                                                    setFieldValue("attachFile", currentAttachFile.filter((_, i) => i !== index));
                                                                    setFieldValue("attachFileType", currentAttachFileType.filter((_, i) => i !== index));
                                                                    setFieldValue("attachFileName", currentAttachFileName.filter((_, i) => i !== index));
                                                                }}
                                                            >
                                                                &#x2715;
                                                            </Button>
                                                        </div >
                                                    </Row >
                                                </Flex>
                                            </Col>
                                        ))}
                                    </>
                                )
                                }

                            </Row>

                            <Flex justify="end">
                                <Space direction="horizontal" size={12}>
                                    <Button
                                        type="default"
                                        style={{ height: "40px", borderRadius: "8px" }}
                                        onClick={() => {
                                            resetFields();
                                            setIsExpenseModalOpen(false);
                                        }}
                                    >
                                        {t("common.cancel").toUpperCase()}
                                    </Button>

                                    <Button
                                        type="default"
                                        style={{ height: "40px", borderRadius: "8px" }}
                                        onClick={() => createTxnExpenseDraft(form)}
                                    >
                                        {t("common.draft").toUpperCase()}
                                    </Button>


                                    <Button
                                        htmlType="submit"
                                        type="primary"
                                        style={{
                                            height: "40px",
                                            borderRadius: "8px",
                                            backgroundColor: "var(--button-color)",
                                            boxShadow: "none",
                                        }}
                                    >
                                        {t("my_timesheet.label.approve").toUpperCase()}
                                    </Button>
                                </Space>
                            </Flex>
                        </Space>
                    );
                }}
            </FormItem >
        </FormAntd >
    )
}

export default CreateExpenseForm;